module.exports = __webpack_public_path__ + "static/media/closet-aqua-logo.a2665c72.svg";